import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser'
import {LiveCasinoService} from "../services/livecasino.service";
import {UserService} from "../services/user.service";
import {ExposureService} from "../services/exposure.service";

@Component({
    selector: 'app-livecasino-igtech',
    templateUrl: './casino.component.html',
    styleUrls: ['./casino.component.css'],
    providers: []
})
export class LivecasinoIgtechComponent implements OnInit {
    user_id = localStorage.getItem("user_id");
    username = localStorage.getItem("username");
    balance = 0;
    vendors: any = [];
    allCategories: any = [];
    categories: any = [];
    gameList: any = [];
    filtered_gameList: any = [];
    gameurl: any = "";
    activeVendor: string = "";
    activeCategory: string = "";
    searchKeyword: string = "";
    isloading: boolean = true;
    is_active: boolean = true;
    clicked = false;
    selectedGame: string = "";
    exposure: any = [];
    currentPage: number = 1;
    totalPages: number = 1;
    private typingTimer: any;
    private doneTypingInterval: number = 500;
    popular_games: any = [
        {
            "game_name": "Aviator",
            "casinoGameId": "aviator",
            "provider": "SPB",
            "description": "Spribe",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Aviator_1697879631441.088.png"
        },
        {
            "game_name": "Auto-Roulette 1",
            "casinoGameId": "225",
            "provider": "PP",
            "description": "Pragmatic Play",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Auto-Roulette_1662035764514.8215.jpg"
        },
        {
            "game_name": "6+ Poker",
            "casinoGameId": "BTV-6poker",
            "provider": "QT",
            "description": "Qtech",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Poker-6_1722498432389.0283.png"
        },
        {
            "game_name": "1Tap Mines",
            "casinoGameId": "TRB-1tapmines",
            "provider": "QT",
            "description": "Qtech",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/1Tap-Mines_1721654154647.2036.png"
        },
        {
            "game_name": "1 Day Dragon Tiger",
            "casinoGameId": "150036",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/1-Day-Dragon-Tiger_1725447005067.8533.png"
        },
        {
            "game_name": "Andar Bahar",
            "casinoGameId": "150007",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Andar-Bahar_1725445527067.6743.png"
        },
        {
            "game_name": "7 Up 7 Down",
            "casinoGameId": "400067",
            "provider": "DC",
            "description": "Dream Casino",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/7up7down_1694793541331.5251.png"
        },
        {
            "game_name": " Aladdin and the Sorcerer",
            "casinoGameId": "vs20aladdinsorc",
            "provider": "PP",
            "description": "Pragmatic Play",
            "logo_square": "http://files.worldcasinoonline.com/Document/Game/Aladdin-and-the-Sorcerer_1662559502173.5122.jpg"
        },
        {
            "game_name": "Pine of Plinko",
            "casinoGameId": "PRS-pineofplinko",
            "provider": "QT",
            "description": "Qtech",
            "logo_square":  "http://files.worldcasinoonline.com/Document/Game/Pine-of-Plinko_1724142014219.104.png"
        },
        {
            "game_name": "Monopoly Big Baller",
            "casinoGameId": "1000419",
            "provider": "EVZ",
            "description": "Evolution - Ezugi",
            "logo_square":  "http://files.worldcasinoonline.com/Document/Game/Monopoly Big Baller_1691069717539.7944.png"
        },
    ];

    constructor(private liveCasinoService: LiveCasinoService, private sanitizer: DomSanitizer, private userService: UserService, private router: Router, private exposureService: ExposureService) {
    }

    ngOnInit(): void {
        this.getVendorList();
       this.onVendorChange(this.getVendorIdFromURL() || 'All');

    }
    
    
     getVendorIdFromURL(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
                console.log('Vendor ID:', urlParams.get('vendorId'));

    return urlParams.get('vendorId');  

    // Assuming the parameter is named 'vendorId'
}

    getVendorList() {
        this.liveCasinoService.getProvidersRequestsIgtech().subscribe((res: any) => {
        if (res.success) {
            this.vendors = Object.entries(res.categories).map(([providerCode, providerData]:any) => ({
                providerCode,providerName: providerData.provider_name
            }));
            this.vendors.unshift({ providerCode: "All", providerName: "All" });
            this.allCategories = res.categories;
            const allCategories = Object.values(res.categories).flatMap((providerData:any) => providerData.categories);
            this.categories = Array.from(new Set(allCategories));
       this.onVendorChange(this.getVendorIdFromURL() || 'All' );
            
        }
        });
    }
    onVendorChange(selectedVendor: string, searchKeyword: any=null) {
        console.log('Vendor ID:', this.activeVendor);

        this.activeVendor = selectedVendor;
        this.searchKeyword = searchKeyword;
        if (selectedVendor === "All") {
            const allCategories = Object.values(this.allCategories).flatMap((providerData:any) => providerData.categories);
            this.categories = Array.from(new Set(allCategories));
        } else {
            this.categories = this.allCategories[selectedVendor].categories;
        }
        // this.onSelectCategory("Popular");
        this.onSelectCategory(this.categories[0]);
    }

    onSelectCategory(category:string) {
        this.activeCategory = category;
        if (category === 'Popular') {
            this.filtered_gameList = this.popular_games;
            this.isloading = false;
            this.totalPages = 1;
            return;
        }
                console.log('Vendor ID:', this.activeVendor);

        if (this.activeCategory) this.getGameList(this.activeVendor,this.activeCategory, null, this.searchKeyword);
    }

    getGameList(provider: string,category:string, page:any=null, searchKeyword:any) {
        this.gameurl = "";
        this.activeVendor = provider;
                console.log('Vendor ID:', category);

        this.isloading = true;
        this.liveCasinoService.getGamesByCategoryRequestsIgtech(provider,category,page,searchKeyword).subscribe((res: any) => {
            this.gameList = res.games;
            this.filtered_gameList = this.gameList;
            this.isloading = false;
            this.totalPages = res.total_pages;
        });
    }
    

    changePage(page: number) {
        if (page > 0 && page <= this.totalPages) {
            this.currentPage = page;
            this.isloading = true;
            this.getGameList(this.activeVendor,this.activeCategory,this.currentPage, this.searchKeyword);
        }
    }
  
    getPaginationRange(): any[] {
        const pages = [];
        pages.push(1);
        if (this.currentPage > 3) {
          pages.push('...');
        }
        for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(this.totalPages - 1, this.currentPage + 1); i++) {
          pages.push(i);
        }
        if (this.currentPage < this.totalPages - 2) {
          pages.push('...');
        }
        if (this.totalPages > 1) {
          pages.push(this.totalPages);
        }
        return pages;
    }

    capitalizeFirstLetter(val:string) {
        return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    onSearch(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = input.value;
    
        clearTimeout(this.typingTimer);
    
        // Set a new timer
        this.typingTimer = setTimeout(() => {
          if (value.trim() !== '') {
            this.onVendorChange("All",value);
          } else {
            this.onVendorChange("All");
          }
        }, this.doneTypingInterval);
    }

    onSearch_local(event: Event) {
        const input = event.target as HTMLInputElement;
        const value = input.value;
    
        clearTimeout(this.typingTimer);
    
        // Set a new timer
        this.typingTimer = setTimeout(() => {
          if (value.trim() !== '') {
            this.filter_games(value);
          } else {
            this.activeCategory = "All";
            //this.activeCategory = this.categories[0];
            this.filtered_gameList = this.gameList;
          }
        }, this.doneTypingInterval);
    }

    filter_games(label: string) {
        this.activeCategory = 'search';
        const normalizedSearchTerm = label.toLowerCase().replace(/\s+/g, '');
        this.filtered_gameList = this.gameList.filter((game:any) => {
            const normalizedGameName = game.game_name.toLowerCase().replace(/\s+/g, '');
            return normalizedGameName.includes(normalizedSearchTerm);
        });
    }

    openCasino(provider: any) {
        this.router.navigate(['/dashboard/casino', provider]);
    }

    getGameUrl(gameid: any) {
        const selectedgame= this.selectedGame;

        const data ={
            gameId: gameid,
            provider: this.selectedGame,
            userId: this.user_id,
            balance: this.balance,
            exposure: this.exposure
        }
        // console.log(data)

        this.liveCasinoService.getGamesUrlByidRequests(data).subscribe((res: any) => {

            this.gameurl = this.sanitizer.bypassSecurityTrustResourceUrl(res.launch_url);
            this.router.navigate(['/casino-detail/', gameid, selectedgame])
        });
    }

    openNewGameTab(gameid: any, provider:any) {
        this.router.navigate(['/casino-detail-igtech/',gameid,provider])
    }

    openLobby() {
        const url = '/casino-detail-igtech/true/lobby';
        window.open(url, '_blank');
    }      

    activateAccount() {
        this.liveCasinoService.activateAccountRequests().subscribe((res: any) => {
            this.is_active=true;
            this.getVendorList();
            alert('Account Activated');
        });
    }

    setSelectedGame(gameName: string) {
        this.selectedGame = gameName;
    }

    getExposureDetails() {
    this.exposureService.getExposure().subscribe((data: any) => {
        this.exposure = data[0].exp_amount;
    }, (error) => {
        this.exposure = [];
    })
    }

    onImageError(event: any) {
        event.target.src = './assets/images/no_images.png';
    }

}
